import {
  AssignmentConfigurations,
  AssignmentSummary,
  Attendee,
  AttendeeSubmission,
  DELETE_ASSIGNMENT_USE_CASE,
  ExaminationAssignment,
  GET_ASSIGNMENTS_USE_CASE,
  GET_ASSIGNMENT_BY_ID_USE_CASE,
  GET_ASSIGNMENT_CONFIGURATIONS_USE_CASE,
  GET_ATTENDEES_USE_CASE,
  GET_ATTENDEE_SUBMISSIONS_USE_CASE,
  PUBLISH_SCORE_USE_CASE,
  PracticeAssignment,
  UPDATE_EXAMINATION_SUBMISSION_USE_CASE,
  COMPLETE_PRACTICE_ASSIGNMENT_USE_CASE,
} from '@module/assignment';
import { RequestStatus, createReducer } from '@lib/plugin-redux-core';
import { UseCaseError } from '@digibricks/core';
import {
  handleDeleteAssignmentUseCase,
  handleGetAssignmentByIdUseCase,
  handleGetAssignmentConfigurationsUseCase,
  handleGetAssignmentUseCase,
  handleGetAttendeeSubmissionUseCase,
  handleGetAttendeesUseCase,
  handlePublishScoreUseCase,
  handleUpdateExaminationSubmissionUseCase,
  handleCompletePracticeAssignmentUseCase,
} from './assignment.handler';

export type AssignmentInitialState = {
  error?: UseCaseError<any>;
  effect: number;
};
export type GetAssignmentsUseCaseState = {
  assignmentResponses: AssignmentSummary[];
  isLoading: boolean;
  getAssignmentSummaryStatus: number;
  assignmentResponseNextToken?: string;
};
export type DeleteAssignmentUseCaseState = {
  deleteAssignmentStatus: number;
  isLoading: boolean;
  deletedAssignmentId: string;
};
export type GetAssignmentConfigurationUseCaseState = {
  assignmentConfigsResponse: AssignmentConfigurations;
  isLoadingConfigs: boolean;
};
export type GetAssignmentByIdUseCaseState = {
  assignmentByIdResponse: PracticeAssignment | ExaminationAssignment;
  getAssignmentByIdStatus: number;
  isLoadingGetById: boolean;
};
export type GetAttendeesUseCaseType = {
  attendeeResponses: Attendee[];
  isLoadingGetAttendees: boolean;
  statusGetAttendee: number;
};
export type GetAttendeeSubmissionsUseCaseState = {
  attendeeSubmissionResponse: AttendeeSubmission;
  isLoadingAttendeeSubmission: boolean;
  statusGetAttendeeSubmission: number;
};
export type PublishScoreUseCaseState = {
  isLoadingPublishScore: boolean;
  publishScoreStatus: number;
};

export type UpdateExaminationSubmissionUseCaseState = {
  updateExaminationSubmissionStatus: RequestStatus;
};

export type CompletePracticeAssignmentUseCaseState = {
  isLoadingCompletePracticeAssignment: boolean;
  completePracticeAssignmentStatus: number;
};

export type AssignmentState = AssignmentInitialState &
  GetAssignmentsUseCaseState &
  DeleteAssignmentUseCaseState &
  GetAssignmentConfigurationUseCaseState &
  GetAssignmentByIdUseCaseState &
  GetAttendeesUseCaseType &
  GetAttendeeSubmissionsUseCaseState &
  PublishScoreUseCaseState &
  CompletePracticeAssignmentUseCaseState &
  UpdateExaminationSubmissionUseCaseState;

const initialState: AssignmentInitialState = {
  error: null,
  effect: 0,
};

export const assignmentReducer = createReducer(initialState, [
  {
    name: GET_ASSIGNMENTS_USE_CASE,
    ...handleGetAssignmentUseCase,
  },
  {
    name: DELETE_ASSIGNMENT_USE_CASE,
    ...handleDeleteAssignmentUseCase,
  },
  {
    name: GET_ASSIGNMENT_CONFIGURATIONS_USE_CASE,
    ...handleGetAssignmentConfigurationsUseCase,
  },
  {
    name: GET_ASSIGNMENT_BY_ID_USE_CASE,
    ...handleGetAssignmentByIdUseCase,
  },
  {
    name: GET_ATTENDEES_USE_CASE,
    ...handleGetAttendeesUseCase,
  },
  {
    name: GET_ATTENDEE_SUBMISSIONS_USE_CASE,
    ...handleGetAttendeeSubmissionUseCase,
  },
  {
    name: PUBLISH_SCORE_USE_CASE,
    ...handlePublishScoreUseCase,
  },
  {
    name: UPDATE_EXAMINATION_SUBMISSION_USE_CASE,
    ...handleUpdateExaminationSubmissionUseCase,
  },
  {
    name: COMPLETE_PRACTICE_ASSIGNMENT_USE_CASE,
    ...handleCompletePracticeAssignmentUseCase,
  },
]);
